import { render } from "./CoordinateData.vue?vue&type=template&id=47e32390"
import script from "./CoordinateData.vue?vue&type=script&lang=js"
export * from "./CoordinateData.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "47e32390"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47e32390', script)) {
    api.reload('47e32390', script)
  }
  
  module.hot.accept("./CoordinateData.vue?vue&type=template&id=47e32390", () => {
    api.rerender('47e32390', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CoordinateData/CoordinateData.vue"

export default script